
<fourd-map-view-component #mapComp></fourd-map-view-component>

    <div class="float-box">
        <h4>Projects</h4>
        <div *ngFor="let proj of projects | async">
            <a [routerLink]="[proj.id,'auto','layers']">{{ proj.name }}</a>
        </div>
    
    </div>

    